import {useRef, useState} from "react";
import {useStateContext} from "../../contexts/ContextProvider";
import LockClosedIcon from "@heroicons/react/20/solid/LockClosedIcon";
import {login} from "../../api/userApiClient";

export default function LoginPage() {
    const [errors, setErrors] = useState(null);
    const {setUser, setToken} = useStateContext();
    const emailRef = useRef(null);
    const passwordRef = useRef(null);

    const handleSubmit = (ev) => {
        ev.preventDefault()

        setErrors(null)

        const email = emailRef.current.value;
        const password = passwordRef.current.value;

        login(email, password)
            .then(
                (data) => {
                    setUser({
                        name  : data.user.name,
                        email : data.user.email,
                        type  : data.user.type,
                    })

                    setToken(data.token)
                })
            .catch(
                err => {
                    setErrors({
                        email : [err.message]
                    })
                })
    }

    return (
        <>
            <div className="flex min-h-screen items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
                <div className="w-full max-w-md space-y-8 bg-white rounded-2xl shadow-sm ring-1 ring-gray-950/5 p-8">
                    <div>
                        <div className="mx-auto h-12 w-12 rounded-xl bg-pink-600 flex items-center justify-center text-white text-xl font-bold">
                            P
                        </div>
                        <h2 className="mt-6 text-center text-2xl font-bold tracking-tight text-gray-900">
                            Login to your account
                        </h2>
                        {errors && <div className="mt-3 text-sm text-red-600 text-center">
                            {
                                Object.keys(errors).map(key => (
                                    <p key={key}>{errors[key][0]}</p>))
                            }
                        </div>
                        }
                    </div>
                    <form onSubmit={handleSubmit} className="mt-8 space-y-4">
                        <div>
                            <label htmlFor="email-address" className="sr-only">
                                Email address
                            </label>
                            <input
                                ref={emailRef}
                                id="email-address"
                                name="email"
                                type="email"
                                autoComplete="email"
                                required
                                className="block w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-400 sm:text-sm"
                                placeholder="Email address"
                            />
                        </div>
                        <div>
                            <label htmlFor="password" className="sr-only">
                                Password
                            </label>
                            <input
                                ref={passwordRef}
                                id="password"
                                name="password"
                                type="password"
                                autoComplete="current-password"
                                required
                                className="block w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-400 sm:text-sm"
                                placeholder="Password"
                            />
                        </div>

                        <div>
                            <button
                                className="group relative flex w-full justify-center items-center gap-2 rounded-lg border border-transparent bg-pink-600 py-2.5 px-4 text-sm font-semibold text-white shadow-sm hover:bg-pink-700 transition-colors focus:outline-none focus:ring-2 focus:ring-pink-500 focus:ring-offset-2"
                            >
                                <LockClosedIcon className="h-4 w-4 text-pink-200" aria-hidden="true"/>
                                Login
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}